<template>
  <div class="order-dropdown" ref="dropdown">
    <div
      class="order-dropdown__selected"
      :class="{ active: !disabled }"
      @click="toggleDropdown"
    >
      <div style="flex: 1" v-if="!isOpen">
        <span
          class="multiple-target-text"
          @click="handleClickSelected"
          v-if="isMultiple"
          >Multi - Target</span
        >
        <div v-if="value.orderCode && !isMultiple" @click="handleClickSelected">
          <div v-if="value.isNew" class="order-dropdown__badge">
            Order ID Baru
          </div>

          <div
            class="order-dropdown__order-code"
            :class="[{ disabled: disabled }]"
          >
            {{ value.orderCode }}
          </div>

          <div class="order-dropdown__batch" :class="[{ disabled: disabled }]">
            (Batch {{ value.batch }})
          </div>
        </div>
      </div>
      <input
        v-else
        @click="$event.stopPropagation()"
        type="text"
        :value="searchInput"
        @input="handleChangeInput"
        :disabled="disabled"
        ref="searchInputRef"
      />

      <div class="order-dropdown__arrow" :class="{ 'is-open': isOpen }">
        <i class="fa fa-chevron-down"></i>
      </div>
    </div>

    <div v-if="isOpen" class="order-dropdown__menu">
      <div v-if="currentOptions.length <= 0">
        <div class="order-dropdown__item text-center">
          Tidak ada order code yang tersedia
        </div>
      </div>
      <div
        v-for="{ label: option, disabled } in currentOptions"
        :key="`${option.orderCode}-${option.batch}`"
        class="order-dropdown__item"
        :class="{
          'is-selected':
            option.orderCode === value.orderCode &&
            option.batch === value.batch,
          'is-disabled': disabled,
        }"
        @click="disabled ? null : selectOption(option)"
      >
        <div v-if="option.isNew" class="order-dropdown__badge">
          Order ID Baru
        </div>

        <div class="order-dropdown__order-code">
          {{ option.orderCode }}
        </div>

        <div class="order-dropdown__batch">(Batch {{ option.batch }})</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderCodeDropdown",

  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({
        orderCode: "",
        batch: "",
        isNew: false,
      }),
    },

    options: {
      type: Array,
      default: () => [],
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    isMultiple: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isOpen: false,
      currentOptions: [],
      searchInput: "",
    };
  },

  mounted() {
    document.addEventListener("click", this.handleOutsideClick);
  },

  beforeDestroy() {
    document.removeEventListener("click", this.handleOutsideClick);
  },

  // Vue 3
  beforeUnmount() {
    document.removeEventListener("click", this.handleOutsideClick);
  },

  watch: {
    options: {
      immediate: true,
      handler(newOptions) {
        this.currentOptions = newOptions;
      },
    },
    isOpen(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.$refs.searchInputRef.focus();
        });
      }
    },
  },

  methods: {
    handleClickSelected(event) {
      event.stopPropagation();
      if (this.disabled) return;
      this.searchInput = "";
      this.currentOptions = this.options;
      this.isOpen = !this.isOpen;
    },
    handleChangeInput(event) {
      const inputValue = event.target.value.trim();
      this.searchInput = inputValue;
      const matchingOption = this.options.filter((option) =>
        option.value.orderCode.toLowerCase().includes(inputValue.toLowerCase())
      );
      this.currentOptions = matchingOption;
    },

    toggleDropdown() {
      this.searchInput = "";
      this.currentOptions = this.options;
      if (this.disabled) return;
      this.isOpen = !this.isOpen;
    },

    selectOption(option) {
      this.searchInput = "";
      this.currentOptions = this.options;
      this.$emit("change", option);
      this.isOpen = false;
    },

    handleOutsideClick(event) {
      this.searchInput = "";
      this.currentOptions = this.options;
      if (this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {
        this.isOpen = false;
      }
    },
  },
};
</script>

<style scoped>
.active {
  background-color: #ffffff !important;
}

.order-dropdown {
  position: relative;
  font-family: inherit;
}

.order-dropdown__selected {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  border: 1px solid #d7dce5;
  border-radius: 8px;
  background: #f7f7f7;
  cursor: pointer;
}

.order-dropdown__arrow {
  color: #a0a7b5;
  transition: transform 0.2s ease;
}

.order-dropdown__arrow.is-open {
  transform: rotate(180deg);
}

.order-dropdown__menu {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  right: 0;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e3e7ee;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  z-index: 999;
  max-height: 300px;
  overflow-y: auto;
}

.order-dropdown__item {
  padding: 18px;
  cursor: pointer;
  border-bottom: 1px solid #eef1f5;
  transition: background 0.2s;
}

.order-dropdown__item:last-child {
  border-bottom: none;
}

.order-dropdown__item:hover {
  background: #f8f9fa;
}

.order-dropdown__item.is-selected {
  background: #f8f9fa;
}

.order-dropdown__item.is-disabled {
  cursor: not-allowed;
  color: #a0a7b5;
  background-color: #eef1f5;
  border-bottom: 1px solid #d7dce5;
}

.order-dropdown__item.is-disabled > .order-dropdown__order-code,
.order-dropdown__item.is-disabled > .order-dropdown__batch {
  color: #a0a7b5;
}

.order-dropdown__badge {
  display: inline-block;
  padding: 2px 8px;
  border: 1px solid #81bcf8;
  border-radius: 6px;
  color: #0953a8;
  font-size: 12px;
  font-weight: 600;
  background-color: #f1f6fe;
  margin-bottom: 8px;
}

.order-dropdown__item.is-disabled > .order-dropdown__badge {
  border-color: #a0a7b5;
  color: #a0a7b5;
  background-color: #e3e7ee;
}

.order-dropdown__order-code {
  font-size: 16px;
  font-weight: 500;
  color: #2e3646;
  line-height: 1.3;
}

.order-dropdown__order-code.disabled,
.order-dropdown__batch.disabled {
  color: #a0a7b5;
}

.order-dropdown__batch {
  margin-top: 4px;
  font-size: 16px;
  font-weight: 500;
  color: #2e3646;
}

input[type="text"] {
  border: none;
  outline: none;
  width: 100%;
  font-size: 16px;
  font-weight: 500;
  color: #2e3646;
}

input[type="text"]:disabled {
  background-color: transparent;
}

.multiple-target-text {
  color: #bdc3c7;
}
</style>


// WEBPACK FOOTER //
// src/components/RentAdjustment/CustomComponent/OrderCodeDropdown.vue